import { PriceValues } from './types'

export const getRrp = ({ price, rrp }: PriceValues) => {
  return parseFloat(price.amount) < parseFloat(rrp.amount)
    ? rrp.displayValue
    : undefined
}
